import {
    LOAD_STORAGELOT_DATA,
    DELETE_A_STORAGELOT,
    SAVE_A_STORAGELOT,
    UPDATE_A_STORAGELOT,
    CLEAR_A_STORAGELOT_ERROR_MESSAGE
} from './actions';
//import {CLEAR_A_TOWJOB_ERROR_MESSAGE} from "../towjob/actions";

const initialState = {
  storagelotsArray:[],
    deleteStoragelotResp:{},
    errorCMsg:{},
    saveStoragelotResp:{},
    updateStoragelotResp:{}
};




export default function reducer(state = initialState, action) {
  switch (action.type) {
      case CLEAR_A_STORAGELOT_ERROR_MESSAGE:
          return Object.assign({}, state, {
              errorCMsg: {}
          });
      case LOAD_STORAGELOT_DATA:
          return Object.assign({}, state, {
              storagelotsArray: action.storagelotsData
          });
          case DELETE_A_STORAGELOT:
          return Object.assign({}, state, {
              deleteStoragelotResp: action.deleteStoragelotResponse,
              errorCMsg: action.errorMsg
          });
      case SAVE_A_STORAGELOT:
          return Object.assign({}, state, {
              saveStoragelotResp: action.saveStoragelotResponse,
              errorCMsg: action.errorMsg
          });
      case UPDATE_A_STORAGELOT:
          return Object.assign({}, state, {
              updateStoragelotResp: action.updateStoragelotResponse,
              errorCMsg: action.errorMsg
          });

    default:
      return state;
  }
}
